<template>
  <div class="user">
    <p class="title">1.客人信息</p>
    <div class="g-content">
      <ul>
        <li>
          <div class="z-title">来电电话</div>
          <div class="z-content"><span v-if="userPhone&&userArea" style="margin-right: 10px;border-right: 1px solid #ccc;padding-right: 10px;">+{{userArea}}</span>{{userPhone}}</div>
        </li>
        <li v-if="isJYJForXL && ((vipPhone && isAmend) || !isAmend)">
          <div class="z-title">会员电话</div>
          <div class="z-content" v-if="!isAmend">
            <div class="m-phone">
              <input type="phone" class="infoReceiverPhone text" placeholder="手机号、固话"
                     v-model="vipPhone"
                     :class="{errorBorder: isPhone(vipPhone) || (isChecked && !vipPhone)}">
              <i class="cross" v-show="vipPhone" @click.stop="vipPhone=''"></i>
            </div>
            <span class="infoReceiverPhoneNum">{{vipPhone ? vipPhone.length : 0}}</span>
            <a class="dark" @click="copyMemberPhone">与来电电话一致</a>
            <span style="color:red;margin-left:5px;" v-show="isPhone(vipPhone)">请输入正确的手机号码格式 8位/10位/11位/3位或4位区号-8位 数字</span>
          </div>
          <div class="z-content" v-else>
            <div class="m-phone">{{vipPhone}}</div>
          </div>
        </li>
        <li>
          <div class="z-title">收货人电话</div>
          <div v-if="userArea">
            <!-- 国际 -->
            <cc-select v-model="countryCode" :width="160" labelKey="name" valueKey="type" :headLabelKey="true" :options="phoneAreaCode" style="top: 9px;margin-right:10px;"
            @change='$onFormChange()'> 
            </cc-select>
            <input type="phone" class="infoReceiverPhone text" placeholder="手机号"
                     v-model="consigneePhone"
                     :maxlength="countryCode=='+86'? 11 : 8"
                     :class="{errorBorder: !isPhoneArea(consigneePhone,countryCode) || (isChecked && !consigneePhone)}">
            <span class="infoReceiverPhoneNum">{{consigneePhone ? consigneePhone.length : 0}}</span>
            <a class="dark" @click="copyPhone">与来电电话一致</a>
            <span style="color:red;margin-left:5px;" v-show="!isPhoneArea(consigneePhone,countryCode)">手机号码格式与区号不匹配</span>
          </div>
          <div v-else class="z-content">
            <!-- 标准 -->
            <div class="m-phone">
              <input type="phone" class="infoReceiverPhone text" placeholder="手机号、固话"
                     v-model="consigneePhone"
                     :class="{errorBorder: isPhone(consigneePhone) || (isChecked && !consigneePhone)}">
              <i class="cross" v-show="consigneePhone" @click.stop="consigneePhone=''"></i>
            </div>
            <span class="infoReceiverPhoneNum">{{consigneePhone ? consigneePhone.length : 0}}</span>
            <a class="dark" @click="copyPhone">与来电电话一致</a>
            <span style="color:red;margin-left:5px;" v-show="isPhone(consigneePhone)">请输入正确的手机号码格式 8位/10位/11位/3位或4位区号-8位 数字</span>
          </div>
        </li>
        <li>
          <div class="z-title">收货人姓名</div>
          <div class="z-content">
            <div class="m-phone infoReceiverName">
              <input type="text" class="text"
                     v-model="consigneeName"
                     :class="{errorBorder: isChecked && !consigneeName}">
              <i class="cross" v-show="consigneeName" @click.stop="consigneeName=''"></i>
            </div>
            <label>
              <input type="radio" name="receiverSex" value="先生" @change="saveConsigneeSex">
              先生
            </label>
            <label>
              <input type="radio" name="receiverSex" value="女士" @change="saveConsigneeSex">
              女士
            </label>
          </div>
        </li>
        <!-- 联系人，联系电话-end -->
      </ul>
    </div>
  </div>
</template>

<script>
  // import * as Com from '@/plugins/util'
  import { getUrlParameter } from '@/utils/assist'
  import { mapState } from 'vuex'
  import CcSelect from '@/components/Select/index';

  export default {
    name: 'modifyUser'
    , data() {
      let urlObj = getUrlParameter();
      return {
        urlObj,
        userPhone: this.consigneePhone || urlObj.userPhone
        , userArea:  urlObj.userArea
        // ,consigneePhone: ''
        // ,consigneeName:''
        , isChecked: true
        , userId: 0
        , phoneAreaCode: [{type: '+852', name: '中国香港(+852)'},{type: '+853', name: '中国澳门(+853)'},{type: '+86', name: '中国大陆(+86)'}]
        , countryCode: this.countryAreaCode || '+852'
        , changeFlag: false
      }
    }
    , mounted() {
      if(this.countryAreaCode){
        this.countryCode = this.countryAreaCode;
      }
      this.$store.dispatch('booking/user/update', {countryCode: this.countryAreaCode || this.countryCode})
      this.getUser()
    }
    , methods: {
      isPhone(text) {
        // RegExp(/^(\d{8}|\d{10}|\d{11}|(\d{3,4}-\d{8}))$/).test(text)
        return text == null || text === '' || false
      },
      $onFormChange(){
        if (this.changeFlag) {
          // 修改选项时操作
          this.consigneePhone= '';
        } else {
          // 进入页面时，页面初始化             
          this.changeFlag = true;
        }
      },
      isPhoneArea(text,code){
        if (text) {
            if (code==86 || code==0) {
              return text == null || text === '' || RegExp(/^\d{11}$/).test(text) || false;
            }else if(code==852){
              return text == null || text === '' || RegExp(/^\d{8}$/).test(text) || false;
            }else if(code==853){
              return text == null || text === '' || RegExp(/^\d{8}$/).test(text) || false;
            } else {
                // callback();
            }
        }
      },
      copyPhone() {
        if(this.urlObj.userArea){
          this.countryCode = '+'+this.urlObj.userArea;
        }
        setTimeout(()=>{
          this.consigneePhone = this.urlObj.userPhone;
        },300)
        // this.consigneePhone = this.urlObj.userPhone;
      },
      copyMemberPhone() {
        this.vipPhone = this.urlObj.userPhone
      },
      saveConsigneeSex(e) {
        if (this.consigneeName.endsWith('先生') || this.consigneeName.endsWith('女士')) {
          this.consigneeName = this.consigneeName.slice(0, -2) + e.target.value
        } else {
          this.consigneeName = this.consigneeName + " " + e.target.value
        }
        if(e.target.value === '先生'){
          this.$store.dispatch('booking/user/update', {
            sex: 1
          })
        }else if(e.target.value === '女士'){
          this.$store.dispatch('booking/user/update', {
            sex: 2
          })
        }
      },
      getUser() { //获取用户上一次下单信息
        if(this.urlObj.userPhone) {
          this.$store.dispatch('booking/user/update', {vipPhone: this.urlObj.userPhone})
        }
        console.log(this.consigneePhone || this.userPhone,this.userArea,111111111);
        this.server
          .get({
            name: "getUser",
            data: {
              phone: this.consigneePhone || this.userPhone,
              countryCode: '+' + this.userArea
            }
          })
          .then(result => {
            let o = {}, data = result.data;
            if (result.status === 1) {
              this.userId = data.user.uid;
              o.data = data.user;
              if (data.addressList) {
                o.historyAddressList = data.addressList;
              }
            } else {
              o.historyAddressList = [];
            }
            this.$store.dispatch('booking/user/update', o);
          })
      }
    }
    , components: {CcSelect}
    , computed: {
      ...mapState({
        brandInfo: state => state.booking.user.brandInfo,
        sex: state => state.booking.user.sex,
        isAmend: state => state.booking.user.orderAmend.isAmend,
      }),
      vipPhone: {
        get() {
          return this.$store.state.booking.user.vipPhone
        },
        set(val) {
          this.$store.dispatch('booking/user/update', {vipPhone: val})
        }
      },
      consigneePhone: {
        get() {
          return this.$store.state.booking.user.phone
        },
        set(val) {
          this.$store.dispatch('booking/user/update', {phone: val})
        }
      },
      consigneeName: {
        get() {
          return this.$store.state.booking.user.name
        },
        set(val) {
          this.$store.dispatch('booking/user/update', {name: val})
        }
      },
      countryAreaCode: {
        get() {
          return this.$store.state.booking.user.countryAreaCode
        },
        set(val) {
          this.$store.dispatch('booking/user/update', {countryAreaCode: val})
        }
      },
      isJYJForXL() {
        return (!window.standardDB && (this.brandInfo.platformKey === 'cfffb941289a08f9(' || this.brandInfo.platformKey === '0198e4d9557e9a23')) || (window.standardDB && (this.brandInfo.platformKey === 'b93a3d359a795d9c' || this.brandInfo.platformKey === 'eed84f190fa141e6'))
      },
    }
    , watch: {
      vipPhone(val) {
        this.$store.dispatch('booking/user/update', {vipPhone: val})
      },
      consigneePhone(val) {
        this.$store.dispatch('booking/user/update', {phone: val})
      },
      consigneeName(val) {
        this.$store.dispatch('booking/user/update', {name: val})
      },
      userArea(val) {
        this.$store.dispatch('booking/user/update', {userArea: val})
      },
      countryCode(val) {
        this.$store.dispatch('booking/user/update', {countryCode: val})
      },
    }
  }
</script>

<style scoped>
  .user {
    margin-bottom: 10px;
  }

  .cross {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 5px;
    margin: auto 0;
    width: 16px;
    height: 16px;
  }

  .cross:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
    height: 2px;
    background-color: #979797;
    transform: rotate(45deg);
  }

  .cross:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
    height: 2px;
    background-color: #979797;
    transform: rotate(-45deg);
  }

  .redBorder {
    border-color: red;
  }

  .infoReceiverName {
    margin-right: 5px;
  }

  .infoReceiverPhoneNum {
    display: inline-block;
    width: 20px;
    text-align: center;
    color: #f47e5a;
  }

  .m-phone {
    display: inline-block;
    position: relative;
  }

  input.text.errorBorder {
    border: 1px solid #f73f3f
  }

  input[type=checkbox], input[type=radio] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    position: relative;
    top: -1px;
    zoom: 1;
    outline: none;
  }

  input[type=radio] {
    position: relative;
    width: 14px;
    height: 14px;
    vertical-align: middle;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 7px;
    box-shadow: none;
    outline: none;
  }

  input[type=radio] {
    border-color: #707e89;
  }

  input[type=radio]:checked {
    border-color: #1e304d;
  }

  input[type=radio]:checked::after {
    content: "";
    position: absolute;
    left: 3px;
    top: 3px;
    width: 6px;
    height: 6px;
    background-color: #1e304d;
    border-radius: 3px
  }

</style>

<style>

</style>



// WEBPACK FOOTER //
// components/Pages/modifyOrder/modifyUser.vue